module.exports = __webpack_public_path__ + "img/maing_fong_logo.82a52c25.svg";